import { Component, ElementRef, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { WorkerMessage } from '../../../../worker/app-workers/shared/worker-message.model';
import { WORKER_TOPIC } from '../../../../worker/app-workers/shared/worker-topic.constants';
import { WorkerService } from '../services/worker.service';
import { environment } from '../../../environments/environment';
import { GlobalService } from '../services/global.service';
import { BackgroundFilesService } from 'src/app/shared/services/background-files.service';
import * as FileSaver from 'file-saver';

@Component({
    selector: 'worker-window',
    templateUrl: './worker-window.component.html',
    styleUrls: ['./worker-window.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WorkerWindowComponent implements OnInit {

	list_process: any = [];
	list_files: any = [];
	workerTopic: string;
	workerServiceSubscription: Subscription;
	currentWorkerMessage: WorkerMessage;
	workerResponse: string;
	width_button: number = 320;
	width_report_box: number = this.width_button;
	subs: Subscription[] = [];
	tokenIsValid: boolean = false;
	showStatusBar: boolean = false;

	@ViewChild('report_name', { static: false }) report_name: ElementRef;
	@ViewChild('file_name', { static: false }) file_name: ElementRef;

	constructor(private _bgFile: BackgroundFilesService, private worker: WorkerService, public _gS: GlobalService) { }

	ngOnInit() {
		this._gS.changesSessionToken$.subscribe(
			data => {
				if (data && !this.tokenIsValid) { // Hasta que haya un token válido crea el worker.
					this.tokenIsValid = true;
					const workerMessage = new WorkerMessage(WORKER_TOPIC.initProcess, { API_URL: environment.apiUrl, token: this._gS.session_token });
					this.onChangesUploadingFiles();
					this.listenForWorkerResponse();
					this.worker.doWork(workerMessage);
					this.worker.initProcess();
					this.getProcess();
				}
			}
		);

		this.worker.changeWorker$.subscribe(data => {
			if (data?.show_status_bar) this.showStatusBar = true;
			else this.showStatusBar = false;
			this.worker.addProcess(data);
		})
	}

	ngOnDestroy(): void {
		if (this.workerServiceSubscription) {
			this.workerServiceSubscription.unsubscribe();
		}
		this.subs.map(s => s.unsubscribe());
	}

	getProcess() {
		if (localStorage.getItem('queueReportSony')) {
			let data = JSON.parse(localStorage.getItem('queueReportSony'))
			this.list_process = data ? data.filter(item => !item.only_progress) : [];
		}
	}

	deleteProcess(event, process) {
		event.stopPropagation()
		event.preventDefault()
		this.worker.deleteProcess(process);
	}

	deleteFile(event, file) {
		event.stopPropagation()
		event.preventDefault()
		this._bgFile.removeFile(file);
	}

	downloadReport(event, file) {
		if (file.isFrontReport) {
			event.stopPropagation();
			event.preventDefault();
			FileSaver.saveAs(file.info.data, file.fileName);
		}
	}

	onOverText(type) {
		let text = type == 'worker' ? this.report_name.nativeElement : this.file_name.nativeElement;
		let width_text = text.offsetWidth + 50 > this.width_button ? text.offsetWidth + 50 : this.width_button;
		this.width_report_box = width_text;
	}

	onOverContainer() {
		this.width_report_box = 500;
	}

	onOutContainer() {
		this.width_report_box = this.width_button
	}

	onOutText(element) {
		this.width_report_box = this.width_button
	}

	toggleViewProcess(process) {
		process.isOpen = !process.isOpen;
	}

	trackByJobId(index, item) {
		return item.job_id;
	}

	private listenForWorkerResponse() {
		this.workerServiceSubscription = this.worker.workerUpdate$
			.subscribe(data => this.workerResponseParser(data));
	}

	private workerResponseParser(message: WorkerMessage) {
		switch (message.topic) {
			case WORKER_TOPIC.initProcess:
				console.log('API init with:' + message.data.API_URL)
				break;

			case WORKER_TOPIC.addProcess:
			case WORKER_TOPIC.deleteProcess:
				localStorage.setItem('queueReportSony', JSON.stringify(message.data.queue))
				this.getProcess();
				console.log('Add / Delete process:', message.data.queue)
				break;

			case WORKER_TOPIC.getStatusReport:
				message.data.queue.map(p => {
					let found = this.list_process.find(pcs => pcs.job_id == p.job_id);
					p.isOpen = found ? found.isOpen : false;
					return p;
				})
				localStorage.setItem('queueReportSony', JSON.stringify(message.data.queue))
				this.getProcess();
				console.log('Status process:' + message.data.queue)
				break;

			default:
				// code...
				break;
		}
	}

	onChangesUploadingFiles() {
		this.subs.push(this._bgFile.pendingFiles$.subscribe(
			(data: Array<any>) => {
				this.list_files = data;
			}
		));
	}

}
